<template>
  <div>
    <div class="contentMenu" :class="{marginCenter:centerBtn}">
      <p v-if="centerBtn" class="back" @click="back">返回上一页</p>
      <div style="height:5px"></div>
      <h4 class="marginl10">创建案件并启动救援</h4>
      <div>
      <div v-if=" apptodo>0 && $route.name == 'appcase'" class="app-aj">
        <div class="appdc padding-20">待处理案件:({{apptodo}}) <span class="app-ba">此处案件为大救星APP用户报案，请尽快处理</span></div>
        <div v-for="(acase,idx) in apptodolst" :key="idx">
          <div class="clan">
            <el-checkbox name="appcaselst" @change="changeAppcase(idx)" v-model="apptodolst[idx].checked"></el-checkbox>
            <span>{{time(acase.obj.reportTs)}}</span>
            <span>由用户<a class="mingc">{{acase.obj.reportUser}}</a>报案</span>
            <span>【{{acase.incidentTypeStr}}】</span>
            <span>出险人:{{acase.victimList!=null&&acase.victimList.length>0?acase.victimList[0].obj.victimName:""}}{{acase.victimList!=null&&acase.victimList.length>0&&judgeNull(acase.victimList[0].insuranceCompany)?"":",在保"}}</span>
            <span>出险地:{{acase.victimList!=null&&acase.victimList.length>0&&acase.generalLocation!=null?setTxt(acase.generalLocation.addr):""}}</span>
          </div>
        </div>
      </div>
      </div>
      <!--B、出险信息-->
      <h5 class="marginl10">A、出险信息
         <span class="padding-20 span_node">案件编号：{{reportcase.caseNo}}</span>
        <span v-if="this.$route.name == 'newstar'" class="padding-20 lisave span_node" @click="centerDialogVisible=true">创建关联案件</span>
      </h5>
      <div class="marginl10">
        <table class="padding-bj pad-0-10" cellpadding="5">
          <tr> 
            <td>
                报案时间:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.reportTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td >
                报案人:
                <el-input placeholder="请输入报案者姓名" v-model="reportcase.reportUser" class="marginl10"  @keydown.native="keydown($event)"></el-input>
                &nbsp;
                <span class="must">*</span>
            </td>
          </tr>
        
          <tr>
            报案电话:
                <el-input placeholder="请输入报案者联系电话" v-model="reportcase.reporterContact" class="marginl10"  @keydown.native="keydown($event)"></el-input>
                &nbsp;
                <span class="must">*</span>
            </td>
            <td>
                出险时间:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.incidentTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
          </tr>
          <tr>
              <td>
                报案方式:
                <el-select v-model="reportcase.caseSrc" placeholder="请选择" class="marginl10" >
                  <el-option v-for="item in casesrclst" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span class="must">*</span>
              </td>
              <td>
                <span class="back-wc" style="float: left;margin-top: 47px;"> 来源说明:</span>              
                <!-- <el-input placeholder="请输入来源说明" v-model="reportcase.caseSrcDesc" class="marginl10"></el-input> -->
                <changeLanguage :changeText='reportcase.caseSrcDesc' style='display: inline-block;' class="marginl10"
                  v-model='reportcase.caseSrcDesc'></changeLanguage>
                &nbsp;
                <!-- <span class="must">*</span> -->
              </td>
            </tr>
            <tr>
              <td>
              <span class="">案件类型:</span>
              <el-select v-model="reportcase.rescueType"  class="marginl10 w213" placeholder="请选择类型"
                filterable>
                <el-option  label="救援" value="100"></el-option>
                <el-option  label="救助" value="200"></el-option>
              </el-select>
              <el-select v-model="reportcase.subIncidentType"  class="marginl10 w213" placeholder="请选择类型"
                filterable>
                <el-option  label="传统救援救助" value="100"></el-option>
                <el-option  label="优先救援服务" value="200"></el-option>
                <el-option  label="星使服务" value="300"></el-option>
                <el-option  label="医疗垫付服务" value="400"></el-option>
              </el-select>
              <span class="">其他服务:</span>
              <el-select multiple collapse-tags v-model="reportcase.otherIncidentType"   class="marginl10 w213" placeholder="请选择类型"
                filterable>
                <el-option  label="紧急医疗转运" value="紧急医疗转运"></el-option>
                <el-option  label="医疗送返" value="医疗送返"></el-option>
                <el-option  label="亲属前往探视" value="亲属前往探视"></el-option>
                <el-option  label="遗体送返" value="遗体送返"></el-option>
                <el-option  label="骨灰送返" value="骨灰送返"></el-option>
                <el-option  label="当地安葬" value="当地安葬"></el-option>
                <el-option  label="当地火化" value="当地火化"></el-option>
                <el-option  label="亲属前往处理后事" value="亲属前往处理后事"></el-option>
                <el-option  label="住院医疗费用担保" value="住院医疗费用担保"></el-option>
                <el-option  label="门急诊医疗费用担保" value="门急诊医疗费用担保"></el-option>
                <el-option  label="照顾未成年子女" value="照顾未成年子女"></el-option>
                <el-option  label="紧急返回常住地" value="紧急返回常住地"></el-option>
                <el-option  label="紧急撤离" value="紧急撤离"></el-option>
                <el-option  label="电话医生" value="电话医生"></el-option>
                <el-option  label="道路救援" value="道路救援"></el-option>
                <el-option  label="门诊安排" value="门诊安排"></el-option>
                <el-option  label="住院安排" value="住院安排"></el-option>
                <el-option  label="休养期间饭店住宿" value="休养期间饭店住宿"></el-option>
                <el-option  label="紧急医疗咨询" value="紧急医疗咨询"></el-option>
                <el-option  label="医疗监护" value="医疗监护"></el-option>
                <el-option  label="安保培训" value="安保培训"></el-option>
                <el-option  label="遗失行李或文件援助" value="遗失行李或文件援助"></el-option>
                <el-option  label="安保服务" value="安保服务"></el-option>
                <el-option  label="保释协调" value="保释协调"></el-option>
                <el-option  label="处方援助" value="处方援助"></el-option>
                <el-option  label="应急现金协调" value="应急现金协调"></el-option>
                <el-option  label="法律援助" value="法律援助"></el-option>
                <el-option  label="照顾老年人" value="照顾老年人"></el-option>
                <el-option  label="境内外体检" value="境内外体检"></el-option>
                <el-option  label="二次诊疗" value="二次诊疗"></el-option>
                <el-option  label="接送机" value="接送机"></el-option>
                <el-option  label="医疗出诊" value="医疗出诊"></el-option>
                <el-option  label="商务翻译" value="商务翻译"></el-option>
                <el-option  label="递送必要医疗设备/药品" value="递送必要医疗设备/药品"></el-option>
                <el-option  label="心理咨询/培训" value="心理咨询/培训"></el-option>
                <el-option  label="会议场地" value="会议场地"></el-option>
                <el-option  label="危机公关处理" value="危机公关处理"></el-option>
                <el-option  label="理赔指导" value="理赔指导"></el-option>              
                <el-option  label="多学科会诊" value="多学科会诊"></el-option>
                <el-option  label="电话医生" value="电话医生"></el-option>
                <el-option  label="医疗机构推介" value="医疗机构推介"></el-option>
                <el-option  label="协助呼叫当地急救资源" value="协助呼叫当地急救资源"></el-option>
                <el-option  label="线上急救指导" value="线上急救指导"></el-option>
                <el-option  label="协调安排急救资源" value="协调安排急救资源"></el-option>
                <el-option  label="紧急担保" value="紧急担保"></el-option>
                <el-option  label="无忧垫付" value="无忧垫付"></el-option>
                <el-option  label="医疗陪同" value="医疗陪同"></el-option>
                <el-option  label="报案陪同" value="报案陪同"></el-option>
                <el-option  label="补办证件" value="补办证件"></el-option>
                <el-option  label="住院探视" value="住院探视"></el-option>
                <el-option  label="生活协助" value="生活协助"></el-option>
                <el-option  label="门诊垫付" value="门诊垫付"></el-option>
                <el-option  label="住院垫付" value="住院垫付"></el-option>
                <el-option  label="手术垫付" value="手术垫付"></el-option>
                <el-option  label="其它垫付" value="其它垫付"></el-option>
                <el-option  label="出行风险评估服务" value="出行风险评估服务"></el-option>
                <el-option  label="大使馆、领事馆信息" value="大使馆、领事馆信息"></el-option>
                <el-option  label="行李延误/遗失援助" value="行李延误/遗失援助"></el-option>
                <el-option  label="护照遗失援助" value="护照遗失援助"></el-option>
                <el-option  label="紧急电话翻译服务/介绍当地翻译服务" value="紧急电话翻译服务/介绍当地翻译服务"></el-option>
                <el-option  label="协助联络家属" value="协助联络家属"></el-option>
                <el-option  label="电话医疗咨询" value="电话医疗咨询"></el-option>
                <el-option  label="住院期间医疗情况的监控与协助" value="住院期间医疗情况的监控与协助"></el-option>
                <el-option  label="医疗翻译服务" value="医疗翻译服务"></el-option>
                <el-option  label="紧急情况随行人员交通费用" value="紧急情况随行人员交通费用"></el-option>
                <el-option  label="紧急口讯传递" value="紧急口讯传递"></el-option>
                <el-option  label="住院安排" value="住院安排"></el-option>
                <el-option  label="电话急救指导" value="电话急救指导"></el-option>
                <el-option  label="协助安排救护车" value="协助安排救护车"></el-option>
                <el-option  label="协助联系家属或紧急联系人" value="协助联系家属或紧急联系人"></el-option>
                <el-option  label="紧急搜救" value="紧急搜救"></el-option>
                <el-option  label="旅行信息咨询服务" value="旅行信息咨询服务"></el-option>
                <el-option  label="重新安排旅行计划" value="重新安排旅行计划"></el-option>
                <el-option  label="协助安排酒店住宿" value="协助安排酒店住宿"></el-option>
                <el-option  label="安排未成年子女回常住国" value="安排未成年子女回常住国"></el-option>
                <el-option  label="院前120转运服务" value="院前120转运服务"></el-option>
              </el-select>
            </td>
            </tr>

                       
        </table>                
      </div>
 <!--B、出险信息-->
      <h5 class="marginl10 margint-10">B、出险信息 </h5>
      <div class="marginl10">
        <div>
          <table class="padding-bj pad-0-10" cellpadding="5">
            <tr>
              <td>
              <span class="">出险人姓名:</span>
              <el-input   v-model="reportcase.victimName" class="marginl10"  placeholder="请选择出险人姓名"></el-input>
              </td>
              <td>
              <span class="">性别:</span>
              <el-select v-model="reportcase.gender" @change="genderselect" placeholder="请选择" class="marginl10 w100">
                <el-option v-for="item in genderlst" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              &nbsp;
            </td>
            </tr>
            <tr>
              <td >
                <span class="">出险人证件:</span>
                <el-input
                  placeholder="请输入出险人证件"
                  v-model="reportcase.idNo"
                  @change="idnochange"
                  class="marginl10"
                ></el-input>
                &nbsp;
                <span class="must">*</span>
                &nbsp;
                <el-button
                  type="primary"
                  size="small"
                  @click="getinsurance()"
                  >查询保单</el-button
                >
              </td>
              <td style="position: relative;">
                <div v-if="insurancePolicyNoShow == true" style="z-index:1000;width: 80%;position: absolute;top: 66px;background: #fff;padding: 18px 20px;border-radius: 4px;border: 1px solid #ebeef5;padding: 12px;color: #606266;line-height: 1.4;text-align: justify;font-size: 14px;box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);word-break: break-all;">①平安寿险普客保单号一般是P开头的<br> ②平安健康险保单号一般是92开头的16位数<br> ③保司自有产品-线下保单查询<br> ④服务清单到云平台-用户保障查询凭单号</div>
                <span class="">保单号码:</span>
                  <el-input
                  placeholder="请输入保单号码"
                  v-model="reportcase.insurancePolicyNo"
                  class="marginl10"
                  @focus="insurancePolicyNoShow = true"
                  @blur="insurancePolicyNoShow = false"
                  @keydown.native="keydown($event)"
                ></el-input>
                <span class="must">*</span>
                &nbsp;
                <el-button
                  type="primary"
                  size="small"
                  @click="getinsurance()"
                  >保单详情</el-button
                >
              </td>
            </tr>
            <tr>
            <td>
              <span class="">所属保险公司:</span>
              <el-select v-model="reportcase.insuranceCompanyId" @change='suoshuFun' class="marginl10 w213" placeholder="请选择保险公司"
                filterable>
                <el-option v-if='item.insti.name' v-for="item in companies" :key="item.id" :label="item.insti.name"
                  :value="item.insti.id"></el-option>
              </el-select>
              <span class="must" @click="ckht()">*查看合同</span>
            </td>
             <td v-if="companies1.length != 0 && reportcase.insuranceCompanyId != ''">
              <span class="">保险公司子公司:</span>
              <el-select v-model="reportcase.subRegulatorId"  class="marginl10 w213"  @change='suoshuFunz' placeholder="请选择保险公司"
                filterable>
                <el-option  v-for="item in companies1" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
              <span class="must">*</span>
            </td>
            
            </tr>

           <tr>
             
            <td v-if="reportcase.subIncidentType != 200 && reportcase.subIncidentType != 300">
              <span class="">产品名称:</span>
              <el-input   v-model="reportcase.caseProductName" class="marginl10" placeholder="平安寿险VIP不用问"></el-input>
            </td>
            <td v-if="reportcase.subIncidentType == 400">
              <span class="">医院名称:</span>
              <el-input   v-model="reportcase.hospitalName" class="marginl10" placeholder="请输入医院名称"></el-input>
            </td>
          </tr>
          <tr>
            <td colspan="2">
                <span style="float: left;margin-top: 37px;">
                      <span class="">出险地:</span>
                        <el-select v-model="reportcase.siteabroadExpr" @change="caseabroad(1)" class="w75" placeholder="境内">
                          <el-option v-for="item in abroad" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                        <span class="must" v-if="reportcase.siteabroadExpr=='境外'">*</span>
                        <el-select v-model="reportcase.nation" v-if="reportcase.siteabroadExpr=='境外'" @change="loadcounties('',false,1)"
                          class="w120" placeholder="请选择国家" filterable>
                          <el-option v-for="item in countries" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <span class="must">*</span>
                        <el-select v-model="reportcase.city" class="w130" placeholder="请选择地区" filterable>
                          <el-option v-for="item in counties" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
                        </el-select>
                        <span class="must">*</span>
                </span>              
              <changeLanguage ref=changeLanguage :changeText='reportcase.addr' :type=1 class="w303" v-model='reportcase.addr' ></changeLanguage>
              <span class="must">*</span>
              <!-- <span class="blue" @click="getGps(1)">获取当前GPS</span> -->
              <div class="w303">
               <el-input style="width:200px" v-model="Longitudeandlatitude"  @blur="Longitudeandlatitudeblur"></el-input>
              <span style="min-width: 240px;display: inline-block;">经度：{{reportcase.latitude}}；纬度：{{reportcase.longitude}}</span>
              <div>
                 <a href="https://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank">获取当前GPS<span class="must">*</span> </a>
              </div>
              </div>             
            </td>
          </tr>
          <tr>
            <td v-if="reportcase.subIncidentType != 200 && reportcase.subIncidentType != 300">
              案件等级：
              <el-radio v-model="reportcase.caseLevel" label="100" border>高度</el-radio>
              <el-radio v-model="reportcase.caseLevel" label="200" border>紧急</el-radio>
              <el-radio v-model="reportcase.caseLevel" label="300" border>一般</el-radio>
              <el-radio v-model="reportcase.caseLevel" label="1000" border>其他</el-radio>
            </td>
          </tr>
          <tr v-if="reportcase.subIncidentType == 400">
             
             <td>
               <span class="">会员号:</span>
               <el-input   v-model="reportcase.vipNo" class="marginl10" placeholder="请输入会员号"></el-input>
             </td>
             <td>
               <span class="">病历号:</span>
               <el-input   v-model="reportcase.medicNo" class="marginl10" placeholder="请输入病历号"></el-input>
             </td>
             <td>
               <span class="">客户案件号:</span>
               <el-input   v-model="reportcase.orderNo" class="marginl10" placeholder="请输入客户案件号"></el-input>
             </td>
           </tr>
          <tr>
            <td>
                <span class="back-wc" style="float: left;margin-top: 47px;"> 医疗诊断:</span>              
                <changeLanguage :changeText='reportcase.medicalInfo' style='display: inline-block;' class="marginl10"
                  v-model='reportcase.medicalInfo'></changeLanguage>
                &nbsp;
              </td>
          </tr>
          <tr>
            <td style="position: relative;">
                <span class="back-wc" style="float: left;margin-top: 47px;"> 救援需求:</span>              
                <changeLanguage :changeText='reportcase.rescueInfo' style='display: inline-block;' class="marginl10"
                  v-model='reportcase.rescueInfo'></changeLanguage>
                  <span style="color:red;position: absolute;top: 50%;width: 100%;">与冯医生进行三方通话，冯医生电话：13512806746</span>
                &nbsp;
              </td>
          </tr>
          <tr>
            <td>
                <span class="back-wc" style="float: left;margin-top: 47px;"> 事故经过:</span>              
                <changeLanguage :changeText='reportcase.incidentDesc' style='display: inline-block;' class="marginl10"
                  v-model='reportcase.incidentDesc'></changeLanguage>
                &nbsp;
              </td>
          </tr>
          <tr>
            <td>
              事故类型：
              <el-radio v-model="reportcase.accidentType" label="100" border>疾病</el-radio>
              <el-radio v-model="reportcase.accidentType" label="200" border>意外</el-radio>
              <el-radio v-model="reportcase.accidentType" label="1000" border>其他</el-radio>
            </td>
          </tr>
          <tr>
            <td>
              服务类型：
              <el-radio v-model="reportcase.newContractType" label="1" border>大包服务</el-radio>
              <el-radio v-model="reportcase.newContractType" label="2" border>小包服务</el-radio>
              <el-radio v-model="reportcase.newContractType" label="3" border>纯服务</el-radio>
            </td>
          </tr>
          <tr v-if="reportcase.subIncidentType == 400">
            <td>
                门诊就医日期:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.patientTime" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
          </tr>
          <tr v-if="reportcase.subIncidentType == 400">
            <td>
                住院/手术起始日期:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.hospitalStartTime" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
          </tr>
          <tr v-if="reportcase.subIncidentType == 400">
            <td>
                住院/手术结束日期:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.hospitalEndTime" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
          </tr>
          </table>
        </div>
      </div>
   
      <div style="text-align: center;margin-top:20px;padding-bottom:20px;">
        <el-button type="primary" class="w200" @click="submitcase(2,false,1)">创立案件</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { detailOrdinaryCase } from "@/views/axios/api.js";
import strutils from "@/util/strutils.js";
import constants from "@/util/constants.js";
import axios from "axios";
import {
  creatCase,
  updataOrdinaryCase,
  addSubUser,
  listSubUser,
  searchBasic,
  creatBasic,
  listDomestic,
  getPolicies,
  getCounties,
  getallGoingCase,
  getAllCoordinatedCases,
  userlist_regulator,
  casecreateEditTempCase,
  regulatorlistservice,
  wGetContract
  
} from "@/views/axios/api.js";
import changeLanguage from "@/components/common/changeLange.vue";
import gpsBox from "@/views/map/searchMap.vue";
import chatRecord from "@/views/cmd_center/chatRecord";
import jianbao from "@/components/par/jianbao";
import countries from "./../js/countries.json";
import ruserId from "./ruserId";
export default {
  data() {
    return {
      insurancePolicyNoShow:false,
      Longitudeandlatitude: "",
      companies1: [],
      fcdBtn: true,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      formRoute: "",
      llrName: JSON.parse(window.localStorage.getItem("insti")),
      tableData: "",
      cooperaterData: [], //联络人表格
      cooperaterDataList: [],
      cooperaterDataList1: [],
      cooperaterCaseArr: [],
      gongzuorenyuanimageUrl: "", //跟地工作人员图片
      jiashuimageUrl: "", //患者家属
      yiliaoimageUrl: "", //医疗图片
      cailiaoimageUrl: "", //线管材料图片
      imageUrl: "", //上传图片
      addContacterDialogVisible: false, //添加新联络人
      showcooperaterDialogVisible: false, //添加
      addcontacterform: {
        name: "",
        mobileNo: "",
        nationalId: "",
        passport: "",
        password: "",
      },
      formLabelWidth: "120px",
      xingshiServiceDialogVisible: false,
      creatAboutText: "",
      initialCaseId: "",
      initialCaseIdBtn: false,
      gpsBtn: false,
      gpsBox: false,
      centerBtn: false,
      typeId: this.$route.query.typeId,
      apptodo: 0,
      apptodolst: [],
      token: JSON.parse(window.localStorage.getItem("data")).data,
      value: "",
      centerDialogVisible: false,
 
      domesticId: "", //国内协调人列表 GET请求参数
      reportcase: {
        contractType:1,
        accidentType:'100',
        newContractType:'1',
        vipNo:'',
        medicNo:'',
        orderNo:'',
        patientTime:'',
        hospitalStartTime:'',
        hospitalEndTime:'',
        rescueInfo:'',
        medicalInfo:'',
        caseLevel:'100',
        hospitalName:'',
        otherIncidentType:'',
        subIncidentType:'100',
        insuranceSeat: "",
        miniPolicy: "",
        caseProductName: "",
        subRegulatorId: "",
        remark: "",
        token: "",
        reportUser: "",
        reportTs: new Date(),
        reporterContact: "",
        incidentTs: "",
        caseSrc: "",
        // caseNo: "4256544",
        caseInsured: 2,
        // addr: "境内",
        nation: "+86",
        city: "",
        siteabroadExpr: "境内",
        addr: "",
        weatherIncident: 2,
        weatherTag: "",
        victimName: "",
        insurancePolicyNo: "",
        idNo: "",
        insuranceCompanyId: "",
        injuredPart: "",
        incidentDesc: "",
        regulatorId: 1,
        incidentType: '900',
        rescueType:'100',
        djxId: "",
        // victimId: '',
        latitude: "",
        longitude: "",
        caseSrcDesc: "", //案件来源中英文
        gender: "",
        initialCaseId: "", //关联的案件ID
        //汇合地点
        addr1: "境内",
        rendezvous: "",
        rlng: "",
        rlat: "1",
        rCountryCode: "+86",
        rCity: "",
        //end
        channel: "",
        channel1: "",
        travelId: "",
        subServiceType: "", //星使类型
        xsStart: "",
        xsEnd: "",
        xsDuration: "0",
        tUploadCnts: [],
        hospital: "",
        attendingDoctor: "",
        adContact: "",
        xsId: "",
        rContact: "",
        objType: "",
      },
      travelAgency: "", //旅行社选择
      policy: null,
      companies: [
        {
          insti: {
            name: "江泰救援",
            id: "1",
          },
          inContract: 1,
        },
      ],
     
      casesrclst: [
        '400-救援热线',
        '400-一键救援',
        '400-邮件报案',
        '400-在线客服',
        '400-400热线',
        "电话报案",
        "邮件报案",
        "其他",
      ],
   
      
      abroad: ["境内", "境外"],
      genderlst: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      countries: [],
      counties: [],
      counties1: [],
      accidentTypes: [
        {
          serviceType: "疏通马桶服务",
          amount: 0,
        },
        {
          serviceType: "开锁服务",
          amount: 0,
        },
        {
          serviceType: "油烟机清洗",
          amount: 0,
        },
        {
          serviceType: "油烟机拆洗",
          amount: 0,
        },
        {
          serviceType: "保洁2小时",
          amount: 0,
        },
        {
          serviceType: "保洁4小时",
          amount: 0,
        },
        {
          serviceType: "擦玻璃小户型（100平米下）",
          amount: 0,
        },
        {
          serviceType: "擦玻璃大户型（100-150平米）",
          amount: 0,
        },
        {
          serviceType: "马桶/坐便疏通",
          amount: 0,
        },
        {
          serviceType: "居家开锁",
          amount: 0,
        },
        {
          serviceType: "抽油烟机清洗",
          amount: 0,
        },
        {
          serviceType: "冰箱清洗",
          amount: 0,
        },
        {
          serviceType: "空调清洗",
          amount: 0,
        },
        {
          serviceType: "洗衣机清洗",
          amount: 0,
        },{
            serviceType: "清洁口腔",
            amount: 0
          },{
            serviceType: "衣物干洗",
            amount: 0
          },{
            serviceType: "全屋打扫",
            amount: 0
          }
      ],
  
      tcm: [
        null,
        {
          name: "江泰救援",
          id: "1",
        },
      ],
      callCase: {
        contactName: "", //对接人
        contactNo: "", //联系方式
        company: "", //公司名称
        description: "",
        caseType: 0, //0 普通 1 咨询
        confirmed: 1, //0 待确认  1 已确认
      },
      fileObj: "",
      restaurants: "",
      nationalMobile: "",
      verifyId2: "",
      imageArr: [],
      alertyb: true,
      nowCaseArr: [],
      nowCaseArr1: [],
      ruserId: "",
    };
  },
  mounted: function () {
    this.countries = countries;
    this.loadcompanies();
    this.loadAppCases();
    this.loadcounties();
    if (this.$route.params.caseList) {
      this.handleAppCase(true, 0, true);
    } else {
      // this.loadcounties();
    }
    if (this.$route.name == "callCase1" || this.$route.name == "newstar1") {
      this.centerBtn = true;
    }
    this.getCooperaterList();
    this.getBriefList();
    this.restaurants = this.loadAll();
    this.getnowCase();
    this.getdata();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.formRoute = from.name;
    });
  },
  components: {
    changeLanguage,
    gpsBox,
    chatRecord,
    jianbao,
    ruserId,
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
  },
  methods: {
    ckht() {
      if(this.reportcase.regulatorId == '') {
        this.$message.error("请选择保险公司");
        return
      }
      wGetContract({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        instiId: this.reportcase.regulatorId,
      }).then((res) => {
       window.open(res.data.obj.contractPaper)
      });
    },
    getinsurance() {
      var z = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/policy/view";
      cmd.data = new Object();
      cmd.data.idNo = this.reportcase.idNo;
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        if (r != null) {
          z.policy = r;
          z.reportcase.insurancePolicyNo = r.docNo;
          z.reportcase.caseInsured = 1;
          z.reportcase.victimName = r.name;
          if (r.regulatorId != null) {
            z.reportcase.insuranceCompanyId = r.regulatorId;
            z.reportcase.regulatorId = r.regulatorId;
            z.reportcase.idNo = r.nationalId;
          }
        }
      };
      s2c(cmd);
      console.log(this.reportcase.insuranceCompanyId);
    },
    keydown(e){
		if(e.keyCode == 32){
			e.returnValue = false
		}
  },
    suoshuFunz() {
      if(this.reportcase.subRegulatorId != '' && this.reportcase.subRegulatorId != null && this.reportcase.subRegulatorId != undefined) {
        regulatorlistservice({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.reportcase.regulatorId,
        subRegulatorId: this.reportcase.subRegulatorId,
      }).then((res) => {
        if (res.data.obj.length != 0) {
          if (this.$route.query.caseId) {
            this.reportcase.accidentType = "";
          }
          this.accidentTypes = res.data.obj;
        }
        console.log(res);
      });
      }
    },
    // objTypechange() {
    //   console.log(this.reportcase.objType)
    // },
    insurancePolicyNoblur() {
      if (
        this.reportcase.insuranceCompanyId != "" &&
        this.reportcase.insuranceCompanyId != null &&
        this.reportcase.insuranceCompanyId != undefined
      ) {
        userlist_regulator({
          token: JSON.parse(window.localStorage.getItem("data")).data,
          regulatorId: this.reportcase.insuranceCompanyId,
        }).then((res) => {
          if(res.data.obj.length > 0) {
            this.reportcase.subRegulatorId = res.data.obj[0].id;
          }
          for (var i = 0; i < res.data.obj.length; i++) {
            if (res.data.obj[i].recognitionCode != null &&  res.data.obj[i].recognitionCode != '') {
              for (
                var k = 0;
                k < res.data.obj[i].recognitionCode.split(",").length;
                k++
              ) {
                for (
                  var j = 0;
                  j < res.data.obj[i].recognitionCode.split(",").length;
                  j++
                ) {
                  if (
                    res.data.obj[i].recognitionCode.split(",")[j] ==
                    this.reportcase.insurancePolicyNo.substring(
                      0,
                      res.data.obj[i].recognitionCode.split(",")[k].length
                    )
                  ) {
                    this.reportcase.subRegulatorId = res.data.obj[i].id;
                    // this.suoshuFunz1()
                  }
                }
              }
            }
          }
          console.log(this.reportcase.subRegulatorId);
        });
      }
      // alert(this.reportcase.insuranceCompanyId)
      // if(this.reportcase.insuranceCompanyId == 8) {
      //   if(this.typeId == 800) {
      //   if(this.reportcase.insurancePolicyNo.length > 20) {
      //   this.$message.error("保单位数超出20位，是否确认继续");
      //   // return;
      // }
      // if(this.reportcase.miniPolicy.length != 0) {
      //   if(this.reportcase.miniPolicy.length > 20) {
      //   this.$message.error("小保单位数超出20位，是否确认继续");
      //   // return;
      // }
      // }
      // }
      // }
    },
    Longitudeandlatitudeblur() {
      if (this.Longitudeandlatitude) {
        var m = this.Longitudeandlatitude.split(",");
        console.log(m);
        this.reportcase.latitude = m[1];
        this.reportcase.longitude = m[0];
      }
      console.log(this.Longitudeandlatitude);
    },
    draft() {
      this.$router.push({
        name: "draft",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.typeId,
        },
      });
    },
    idnochange() {
      if (this.reportcase.idNo.length == 18) {
        var str2 = this.reportcase.idNo;
        var num = str2.charAt(16);
        //console.log(num);
        if (num % 2 == 0) {
          console.log("女");
          this.reportcase.gender = 2;
        } else {
          this.reportcase.gender = 1;
          console.log("男");
        }
      }
    },
    accidentTypechange() {
      if (this.reportcase.accidentType == "疏通马桶服务") {
      } else {
      }
    },
    getdata() {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.reportcase.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
    },
    addSubUserFun() {
      this.showcooperaterDialogVisible = true;
      setTimeout(() => {
        this.toggleSelection(this.cooperaterDataList);
      }, 500);
    },
    listDomestic(id) {
      //协调人
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        caseId: id,
      };
      listDomestic(data)
        .then((res) => {
          this.cooperaterDataList = res.data.obj;
          var cooperaterDataList = [];
          this.cooperaterDataList.forEach((item) => {
            this.cooperaterData.forEach((item1) => {
              if (item1.id == item.id) {
                cooperaterDataList.push(item1);
              }
            });
          });
          this.cooperaterDataList = cooperaterDataList;
          // this.toggleSelection(cooperaterDataList)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadAll() {
      var that = this;
      fetch(constants.domain + "rescue/xingshi/search_agent", {
        method: "POST",
        body: `token=${this.token}&name=`,
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          // console.log(data.obj,'所有旅行社')
          that.restaurants = data.obj;
        });
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (travelName) => {
        // console.log(travelName,'单车')
        return (
          travelName.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    setTime(str) {
      return constants.time(str);
    },
    setTxt(str, status) {
      var data = constants.setTxt(str, status);
      if (data) {
        return data;
      } else {
        return str;
      }
    },
    back() {
      this.$router.go(-1);
    },
    //获取国内协调人列表
    getCooperaterList() {
      var data = {
        token: this.token,
        count: 100,
        start: 0,
        all: 1,
      };
      listSubUser(data)
        .then((res) => {
          this.cooperaterData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addSubUser() {
      var that = this;
      var data = {};
      if (this.addcontacterform.name == "") {
        this.$message.error("姓名不能为空");
      } else if (this.addcontacterform.mobileNo == "") {
        this.$message.error("手机号不能为空");
      } else if (this.addcontacterform.nationalId == "") {
        this.$message.error("证件号码不能为空");
      } else if (this.addcontacterform.passport == "") {
        this.$message.error("登录名不能为空");
      } else if (this.addcontacterform.password == "") {
        this.$message.error("密码不能为空");
      } else {
        // data = this.addcontacterform;
        data = Object.assign(this.addcontacterform, {
          token: this.token,
        });
        addSubUser(data)
          .then((res) => {
            if (res.data.code == 0) {
              this.addContacterDialogVisible = false;
              that.getCooperaterList();
              this.$refs.ruleForm.resetFields();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //上传图片
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      // console.log(this.imageUrl)
    },
    requestFile(param) {
      // this.uploadBtn=true;
      var fileObj = param.file;
      console.log(param, "图片擦书");
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      var form = new FormData(); // FormData 对象
      var token = JSON.parse(window.localStorage.getItem("data")).data;
      form.append("file", fileObj); // 文件对象
      form.append("token", token); // 文件对象
      // form.append('caseId', '')
      axios
        .post(constants.domain + "rescue/case/upload_file", form, config)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            // this.fileUrl.push(res.data.obj);
            // this.uploadBtn=false;
            if (param.action == "gongzuorenyuanimageUrl") {
              this.gongzuorenyuanimageUrl = res.data.obj;
              var gongzuorenyuanObj = {
                description: "跟地接社工作人员照片",
                objType: "15",
                url: res.data.obj,
              };
              this.imageArr.push(gongzuorenyuanObj);
            } else if (param.action == "jiashuimageUrl") {
              this.jiashuimageUrl = res.data.obj;
              var jiashuObj = {
                description: "患者家属照片",
                objType: "16",
                url: res.data.obj,
              };
              this.imageArr.push(jiashuObj);
            } else if (param.action == "yiliaoimageUrl") {
              this.yiliaoimageUrl = res.data.obj;
              var yiliaoObj = {
                description: "所在医疗机构及科室的照片",
                objType: "17",
                url: res.data.obj,
              };
              this.imageArr.push(yiliaoObj);
            } else if (param.action == "cailiaoimageUrl") {
              this.cailiaoimageUrl = res.data.obj;
              var cailiaoObj = {
                description: "医疗证明及其他相关材料照片",
                objType: "18",
                url: res.data.obj,
              };
              this.imageArr.push(cailiaoObj);
            }
          }
          // console.log(JSON.stringify(this.imageArr))
          this.reportcase.tUploadCnts = JSON.stringify(this.imageArr);
          console.log(this.reportcase.tUploadCnts);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
      return true;
    },
    //获取简报
    getBriefList() {
      fetch(constants.domain + "rescue/xingshi/list_brief", {
        method: "POST",
        body: `token=${this.token}&caseId=&count=10&start=1`,
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {});
    },
    changeAppcase(idx) {
      // this.reportcase.latitude = '';
      // this.reportcase.longitude = '';
      this.reportcase.rlat = "";
      this.reportcase.rlng = "";
      this.handleAppCase(true, idx);
    },
    suoshuFun() {
      console.log(this.reportcase.insuranceCompanyId);
      console.log(this.reportcase.insurancePolicyNo);
      if (
        this.reportcase.insurancePolicyNo != "" &&
        this.reportcase.insurancePolicyNo != null &&
        this.reportcase.insurancePolicyNo != undefined
      ) {
        userlist_regulator({
          token: JSON.parse(window.localStorage.getItem("data")).data,
          regulatorId: this.reportcase.insuranceCompanyId,
        }).then((res) => {
          for (var i = 0; i < res.data.obj.length; i++) {
            if (res.data.obj[i].recognitionCode != null &&  res.data.obj[i].recognitionCode != '') {
              for (
                var k = 0;
                k < res.data.obj[i].recognitionCode.split(",").length;
                k++
              ) {
                for (
                  var j = 0;
                  j < res.data.obj[i].recognitionCode.split(",").length;
                  j++
                ) {
                  if (
                    res.data.obj[i].recognitionCode.split(",")[j] ==
                    this.reportcase.insurancePolicyNo.substring(
                      0,
                      res.data.obj[i].recognitionCode.split(",")[k].length
                    )
                  ) {
                    this.reportcase.subRegulatorId = res.data.obj[i].id;
                    // this.suoshuFunz1()
                  }
                }
              }
            }
          }
          console.log(this.reportcase.subRegulatorId);
        });
      }
      this.reportcase.regulatorId = this.reportcase.insuranceCompanyId;
      this.reportcase.subRegulatorId = "";
      this.insurancePolicyNoblur();
      this.getdata();
    },
    genderselect() {
      if (this.reportcase.gender == "女" || this.reportcase.gender == 2) {
        this.reportcase.gender = 2;
      } else {
        this.reportcase.gender = 1;
      }
      // console.log(this.reportcase.gender + "-" + this.reportcase.gender);
    },
    //查询出险人手机号
    queryPhone() {
      var data = {
        token: this.token,
        nationalMobile: this.nationalMobile,
      };
      searchBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.obj == null) {
            this.$message("没有查询到您的信息，请先去创建");
          } else {
            this.reportcase.victimName =
              res.data.obj.realName || res.data.obj.name;
            this.reportcase.djxId = res.data.obj.id;
            if (res.data.obj2.verifyId) {
              this.verifyId2 = res.data.obj2.verifyId;
            } else {
              this.verifyId2 = res.data.obj2.verifyId2;
            }
            this.reportcase.idNo = this.verifyId2;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询保单
    B_queryBaodanClick() {
      if (this.reportcase.idNo == "")
        return this.$message.error("请输入出险人证件");
      var data = {
        token: this.token,
        hit: this.verifyId2,
      };
      getPolicies(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0 && res.data.obj.length != 0) {
            this.reportcase.insurancePolicyNo = res.data.obj[0].docNo;
            this.reportcase.insuranceCompanyId = res.data.obj[0].regulatorId;
            this.reportcase.caseInsured = 1;
          } else {
            this.$message.error("未查询到，保单号码");
            this.reportcase.caseInsured = 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //创建大救星账户
    newDJXid() {
      if (this.reportcase.victimName == "") {
        return this.$message.error("创建账户时出险人姓名不能为空");
      } else if (this.nationalMobile == "") {
        return this.$message.error("创建账户时手机号不能为空");
      }
      var data = {
        token: this.token,
        name: this.reportcase.victimName,
        nationalMobile: this.nationalMobile,
      };
      creatBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("创建成功");
            this.reportcase.djxId = res.data.obj.id;
            this.dialogFormVisible3 = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAppCase(checked, idx, params, data) {
      var z = this;
      var ow = null;
      if (params) {
        ow = this.$route.params.caseList;
        this.initialCaseIdBtn = true;
      } else {
        if (data) {
          ow = data.obj;
          this.initialCaseIdBtn = true;
        } else {
          ow = z.apptodolst[idx];
        }
      }
      if (checked) {
        for (var i = 0; i < z.apptodolst.length; ++i) {
          var o1 = z.apptodolst[i];
          if (i != idx) {
            o1.checked = false;
          } else {
            o1.checked = true;
          }
        }
        if (ow != null) {
          this.reportcase.otherTypeName = ow.obj.otherTypeName;
          var o = ow.obj;
          
          z.reportcase.coupon_discount_id =
            ow.helpOrder && ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).coupon_discount_id
              : "";
          z.reportcase.idProfitRedeem =
            ow.helpOrder && ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).idProfitItem
              : "";
          z.reportcase.couponName =
            ow.helpOrder && ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).couponName
              : "";
          z.reportcase.xsId = ow.helpOrder ? ow.helpOrder.id : "";
          z.reportcase.incidentId = o.id;
          z.reportcase.initialCaseId = o.initialCaseId;
          if (o.initialCaseId) {
            z.initialCaseId = o.initialCaseId;
          }
          z.reportcase.reportUser = o.reportUser;
          z.reportcase.remark = o.remark;
          z.reportcase.caseProductName = o.caseProductName;
          z.reportcase.subRegulatorId = o.subRegulatorId;
          if(o.otherIncidentType.length != 0) {
            o.otherIncidentType = o.otherIncidentType.replace(/\s/g, "");
          z.reportcase.otherIncidentType = o.otherIncidentType.split(",");
        
          }
      
          if(this.$route.query.caseId) {
          z.reportcase.rescueType = JSON.stringify(o.rescueType) 
          z.reportcase.subIncidentType = JSON.stringify(o.subIncidentType)
          z.reportcase.caseLevel = JSON.stringify(o.caseLevel)
          }else {
          z.reportcase.rescueType = '100'
          z.reportcase.subIncidentType = '100'
          z.reportcase.caseLevel = '100'
          }
          z.reportcase.vipNo = o.vipNo
          z.reportcase.medicNo = o.medicNo
          z.reportcase.orderNo = o.orderNo
          z.reportcase.medicalInfo = o.medicalInfo
          z.reportcase.rescueInfo = o.rescueInfo
          z.reportcase.incidentDesc = o.incidentDesc
          console.log(o.accidentType)
          z.reportcase.accidentType = JSON.stringify(o.accidentType)
          z.reportcase.newContractType = JSON.stringify(o.newContractType)
          z.reportcase.patientTime = o.patientTime
          z.reportcase.hospitalStartTime = o.hospitalStartTime
          z.reportcase.hospitalEndTime = o.hospitalEndTime
          z.reportcase.hospitalName = o.hospitalName
          console.log(o)
          if (o.reportTs != null) z.reportcase.reportTs = o.reportTs;
          z.reportcase.reporterContact = o.reporterContact;
          if (o.incidentTs != null) {
            z.reportcase.incidentTs = o.incidentTs;
          } else {
            z.reportcase.incidentTs = new Date();
          }
          z.reportcase.caseSrc = o.caseSrc;
          z.reportcase.caseNo = o.caseNo;
          z.reportcase.caseInsured = o.caseInsured;
          if (ow.generalLocation != null) {
            var loc = ow.generalLocation;
            console.log(loc);
            z.reportcase.siteabroadExpr = loc.nation == "+86" ? "境内" : "境外";
            z.reportcase.nation = loc.nation;

            z.reportcase.city = loc.city;
            z.reportcase.addr = loc.addr;
            z.reportcase.latitude = loc.latitude;
            z.reportcase.longitude = loc.longitude;
            z.loadcounties();
            console.log(z.reportcase.addr);
          } else {
            z.reportcase.siteabroadExpr = "";
            z.reportcase.nation = "";
            z.reportcase.city = "";
            z.reportcase.addr = "";
          }
          if (o.weatherIncident) {
            z.reportcase.weatherIncident = o.weatherIncident;
          }
          z.reportcase.weatherTag = o.weatherTag;
          if (o.accidentType) {
            z.reportcase.accidentType = o.accidentType;
          }
          console.log(ow);
          if (ow.helpOrder != null) {
            if (
              JSON.parse(ow.helpOrder.extra).serviceType != "" &&
              JSON.parse(ow.helpOrder.extra).serviceType != null &&
              JSON.parse(ow.helpOrder.extra).serviceType != undefined
            ) {
              if (JSON.parse(ow.helpOrder.extra).serviceType == 100) {
                z.reportcase.accidentType = "疏通马桶服务";
              } else if (JSON.parse(ow.helpOrder.extra).serviceType == 200) {
                z.reportcase.accidentType = "开锁服务";
              }
            }
          }
          // if(this.typeId == 800) {
          //   z.reportcase.accidentType = ''
          // }
          if (ow.victimList != null && ow.victimList.length > 0) {
            var vict = ow.victimList[0].obj;
            z.reportcase.victimName = vict.victimName;
            z.reportcase.gender = vict.gender;
            z.reportcase.insurancePolicyNo = vict.insurancePolicyNo
              ? vict.insurancePolicyNo
              : ow.helpOrder.extra
              ? JSON.parse(ow.helpOrder.extra).policyNo
              : "";
            z.reportcase.idNo = vict.idNo;
            if (vict.insuranceCompanyId != null) {
              z.reportcase.insuranceCompanyId = vict.insuranceCompanyId;
            } else {
              z.reportcase.insuranceCompanyId = 1;
            }
            this.reportcase.djxId = ow.victimList[0].obj.djxId;
            this.reportcase.contact = ow.victimList[0].obj.contact;
            this.reportcase.insurancePaper =
              ow.victimList[0].obj.insurancePaper;
            // this.reportcase.victimId = ow.victimList[0].obj.id;
            z.reportcase.injuredPart = ow.victimList[0].obj.injuredPart;
          } else {
            z.reportcase.victimName = "";
            z.reportcase.gender = "";
            z.reportcase.insurancePolicyNo =
              ow.helpOrder && ow.helpOrder.extra
                ? JSON.parse(ow.helpOrder.extra).policyNo
                : "";
            z.reportcase.idNo = "";
            z.reportcase.insuranceCompanyId = 1;
          }
          z.reportcase.regulatorId = z.reportcase.insuranceCompanyId;
          // if(JSON.parse(this.$route.params.caseList.helpOrder.extra) != '' && JSON.parse(this.$route.params.caseList.helpOrder.extra) != null && JSON.parse(this.$route.params.caseList.helpOrder.extra) != undefined) {
          //     this.reportcase.idProfitRedeem = JSON.parse(this.$route.params.caseList.helpOrder.extra).idProfitItem
          // }
          z.reportcase.caseSrcDesc = o.caseSrcDesc;
          if (this.$route.name == "callCase1" && ow.insuranceContact) {
            this.callCase.contactName = ow.insuranceContact.contactName;
            this.callCase.company = ow.insuranceContact.company;
            this.callCase.contactNo = ow.insuranceContact.contactNo;
            this.callCase.description = ow.insuranceContact.description;
          }
        }
      }
    },
    //删除案件中的国内联络人
    handleClick(index) {
      this.cooperaterDataList.splice(index, 1);
    },
    //导入案件
    loadcounties(data1, status, id) {
      var country = "";
      if (id == 1) {
        country = this.reportcase.nation;
      } else {
        country = this.reportcase.rCountryCode;
      }
      var data = {
        token: this.token,
        country,
      };
      console.log(data);
      getCounties(data)
        .then((res) => {
          var Btn = false;
          if (!status) {
            this.counties = uniq(res.data.obj);
            this.counties1 = uniq(res.data.obj);
            return;
          }
          if (id == 1) {
            this.counties = uniq(res.data.obj);
            if (data1.country == "中国") {
              this.reportcase.siteabroadExpr = "境内";
            } else {
              this.reportcase.siteabroadExpr = "境外";
            }
            console.log(data1.cityCode);
            if (data1.cityCode) {
              this.reportcase.city = data1.cityCode;
              this.counties.forEach((item) => {
                if (item.cityCode == data1.cityCode) {
                  Btn = true;
                }
              });
              if (!Btn) {
                console.log(item.cityCode + "," + data1.cityCode);
                this.$message.error("未自动选择城市，请手动选择");
                this.reportcase.city = "";
              }
            } else {
              console.log(item.cityCode + "," + data1.cityCode);
              this.$message.error("未自动选择城市，请手动选择");
              this.reportcase.city = "";
            }
          } else {
            this.counties1 = uniq(res.data.obj);
            if (data1.country == "中国") {
              this.reportcase.addr1 = "境内";
            } else {
              this.reportcase.addr1 = "境外";
            }
            if (data1.cityCode) {
              this.reportcase.rCity = data1.cityCode;
              this.counties1.forEach((item) => {
                if (item.cityCode == data1.cityCode) {
                  Btn = true;
                }
              });
              if (!Btn) {
                console.log(item.cityCode + "," + data1.cityCode);
                this.$message.error("未自动选择城市，请手动选择");
                this.reportcase.rCity = "";
              }
            } else {
              console.log(item.cityCode + "," + data1.cityCode);
              this.$message.error("未自动选择城市，请手动选择");
              this.reportcase.rCity = "";
            }
          }
        })
        .catch((err) => {
          console.log(res);
        });
    },
    loadcompanies() {
      var z = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/user/list_regulator";
      cmd.data = new Object();
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        z.companies = r;
        var ntcm = new Object();
        for (var i = 0; i < r.length; ++i) {
          var nt = r[i];
          ntcm[nt.insti.id] = nt;
        }
        z.tcm = ntcm;
      };
      s2c(cmd);
    },
    showinsurance() {
      if (this.policy != null) {
        window.open(this.policy.detailUrl);
      }
    },

    caseabroad(id) {
      if (id == 1) {
        if (this.reportcase.siteabroadExpr == "境内") {
          this.reportcase.nation = "+86";
        } else {
          this.reportcase.nation = "";
        }
      } else {
        if (this.reportcase.addr1 == "境内") {
          this.reportcase.rCountryCode = "+86";
        } else {
          this.reportcase.rCountryCode = "";
        }
      }
      this.loadcounties();
    },
    loadAppCases() {
      var _this = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/case/list_case_collection";
      cmd.data = new Object();
      cmd.data.status = 90;
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        _this.apptodo = r.length;
        if (_this.apptodo && _this.apptodo > 0) {
          var rr = [];
          for (var i = 0; i < _this.apptodo; i++) {
            var o1 = r[i];
            o1.checked = false;
            _this.apptodolst.push(o1);
          }
          var index1 = "";
          if (_this.$route.query.caseId) {
            _this.apptodolst.forEach((item, index) => {
              if (item.victimList[0].obj.id == _this.$route.query.caseId) {
                index1 = index;
              }
            });
            _this.changeAppcase(index1);
          }
        } else if (_this.$route.query.caseId) {
          var data = {
            token: _this.token,
            caseId: _this.$route.query.caseId,
          };
          detailOrdinaryCase(data)
            .then((res) => {
              _this.handleAppCase(true, 0, false, res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      };
      s2c(cmd);
    },
    successTo() {
      this.$router.push({
        name: "ComAwait",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.typeId,
        },
      });
    },

    submitcase(type, status,type2) {
      if(Array.isArray(this.reportcase.otherIncidentType)) {
        this.reportcase.otherIncidentType = this.reportcase.otherIncidentType.join(',');
      }
     
      console.log(this.reportcase.otherIncidentType)
      // return
      //insuranceCompanyId
      // this.$router.push({
      //               name: 'helpStart'
      //             })
      var z = this;
      console.log(this.companies1.length, this.reportcase.subRegulatorId);
      console.log(type)
      if (type == 2) {
        var data = {};
        if (this.$route.query.creat) {
          //从创建关联案件过来的为创建案件
          this.initialCaseIdBtn = false;
        }
        console.log(this.initialCaseIdBtn,1608)
        console.log(this.initialCaseId,1609)
        if (this.initialCaseIdBtn) {
          //补充案件的时候不要关联ID
          // delete this.reportcase.initialCaseId; //关联案件IDinitialCaseId
        } else {
          //创建
          this.reportcase.initialCaseId = this.initialCaseId;
          delete this.reportcase.id;
          delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
          if (this.typeId != 800) {
            delete this.reportcase.incidentId;
            delete this.reportcase.xsId;
          }
        }
        delete this.reportcase.caseNo;
        // if (this.$route.query.creat == 1) {
        //   this.reportcase.incidentId = this.$route.query.caseId;
        // }
        // this.reportcase.originCaseId = this.$route.query.caseId;
        
        delete this.reportcase.incidentId;
        // if (stil.judgeNull(this.reportcase.subServiceType)) {
        //   this.$message.error("案件类型不能为空");
        //   return;
        // }
        // if(this.reportcase.insuranceCompanyId == 8) {
        //   if(this.typeId == 800) {
        //   if(this.reportcase.insurancePolicyNo.length > 20) {
        //   this.$message.error("保单位数超出20位，是否确认继续");
        //   // return;
        // }
        // if(this.reportcase.miniPolicy.length != 0) {
        //   if(this.reportcase.miniPolicy.length > 20) {
        //   this.$message.error("小保单位数超出20位，是否确认继续");
        //   // return;
        // }
        // }
        // }
        // }
        if(this.reportcase.rescueType == '') {
          this.$message.error("类型不能为空");
          return;
        }
        if(this.reportcase.subIncidentType == '') {
          this.$message.error("子类型不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportTs)) {
          this.$message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          this.$message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          this.$message.error("报案电话不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.incidentTs)) {
          this.$message.error("出险时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.caseSrc)) {
          this.$message.error("案件来源不能为空");
          return;
        }
        // if (stil.judgeNull(this.reportcase.caseSrcDesc)) {
        //   this.$message.error("来源说明不能为空");
        //   return;
        // }
        // if (stil.judgeNull(this.reportcase.channel)) {
        //   this.$message.error("渠道不能为空");
        //   return;
        // }
        // 100
        // 180
        // 110
        // 111
        if (this.reportcase.channel == "旅责险") {
          if (stil.judgeNull(this.reportcase.travelId)) {
            this.$message.error("旅行社名称不能为空");
            return;
          }
        } else {
          if (
            this.reportcase.channel1 == "其他" ||
            this.reportcase.channel == "其他"
          ) {
            this.$message.error("旅行社名称不能为空");
            return;
          }
        }

        if (
          stil.judgeNull(this.reportcase.nation) ||
          stil.judgeNull(this.reportcase.city) ||
          stil.judgeNull(this.reportcase.addr)
        ) {
          this.$message.error("出险地不能为空");
          return;
        }
        if (this.reportcase.latitude == "" || this.reportcase.longitude == "") {
          this.$message.error("出险地经纬度不能为空");
          return;
        }
        // if (this.reportcase.rlng == '' || this.reportcase.rlat == '') {
        // 	this.$message.error("汇合地点经纬度不能为空");
        // 	return;
        // }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (this.reportcase.weatherIncident != 1) {
          this.reportcase.weatherTag = null;
        }
        if (!constants.setTxt(this.reportcase.addr)) {
          this.reportcase.addr = `<zh-CN>${this.reportcase.addr}</zh-CN><en-US></en-US>`;
        }
        if (!constants.setTxt(this.reportcase.incidentDesc)) {
          this.reportcase.incidentDesc = `<zh-CN>${this.reportcase.incidentDesc}</zh-CN><en-US></en-US>`;
        }
        // if (!this.reportcase.djxId) {
        //   this.$message.error('没有检测到星使id，请查询或创建大救星账号')
        //   return
        // }
        if (this.companies1.length != 0) {
          if (this.reportcase.subRegulatorId == "") {
            this.$message.error("保险公司子公司不能为空");
            return;
          }
        }
        //电话报案
        this.reportcase.token = this.token;
        this.reportcase.incidentTs = new Date(
          this.reportcase.incidentTs
        ).getTime();
        if(this.reportcase.patientTime != '') {
          this.reportcase.patientTime = new Date(
          this.reportcase.patientTime
        ).getTime();
        }
        if(this.reportcase.hospitalStartTime != '') {
          this.reportcase.hospitalStartTime = new Date(
          this.reportcase.hospitalStartTime
        ).getTime();
        }
        if(this.reportcase.hospitalEndTime != '') {
          this.reportcase.hospitalEndTime = new Date(
          this.reportcase.hospitalEndTime
        ).getTime();
        }
       
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime();
        if (this.reportcase.xsStart) {
          this.reportcase.xsStart = new Date(this.reportcase.xsStart).getTime(); //起始时间
        }
        if (this.reportcase.xsEnd) {
          this.reportcase.xsEnd = new Date(this.reportcase.xsEnd).getTime();
        }
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1;
        }
       
        this.domesticId = "";
        this.cooperaterDataList.forEach((item, index) => {
          if (index < this.cooperaterDataList.length - 1) {
            this.domesticId += "domesticId=" + item.id + "&";
          } else {
            this.domesticId += "domesticId=" + item.id;
          }
        });
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1;
        } else {
          this.reportcase.caseInsured = 2;
        }
        if (this.reportcase.channel == "旅责险") {
          this.reportcase.caseInsured = 3;
        }

        // if (this.reportcase.caseInsured == 1 && this.alertyb) {
        //   this.dialogFormVisible1 = true;
        //   return;
        // }
        console.log(status)
        // if (!this.fcdBtn) return this.$message('不要重复点击')
        // this.fcdBtn = false
        if (this.ruserId != "") {
          this.domesticId = this.domesticId + "&" + this.ruserId;
        }
        if (this.reportcase.channel == "其他") {
          this.reportcase.channel = this.reportcase.channel1;
        }
        if (type2 == 1) {
          this.reportcase.caseState = '100';
        }else {
          this.reportcase.caseState = '180';
        }
        data = Object.assign(this.reportcase, this.callCase);
        console.log(status)
        if (!status) {
            creatCase(data, this.domesticId)
            .then((res) => {
              if (res.data.code == 0) {
                if(type2 == 1) {
                this.$message.success("操作成功");
                if (this.$route.name == "newstar") {
                  this.$router.push({
                    name: "rescueList",
                    query: { typeId: 900 },
                  });
                } else {
                  this.$router.push({
                    name: "rescueList",
                    query: { typeId: 900 },
                  });
                }
              }else {
                this.$message.success("操作成功");
                if (this.$route.name == "newstar") {
                  this.$router.push({
                    name: "rescueList2",
                    query: { typeId: 900 },
                  });
                } else {
                  this.$router.push({
                    name: "rescueList2",
                    query: { typeId: 900 },
                  });
                }
               }
              }else {
                this.reportcase.otherIncidentType = this.reportcase.otherIncidentType.replace(/\s/g, "");
                this.reportcase.otherIncidentType = this.reportcase.otherIncidentType.split(",");
              }
            })
            .catch((err) => {
              this.fcdBtn = true;
              console.log(err);
            });
         
          
        } else {
          updataOrdinaryCase(data, this.domesticId)
            .then((res) => {
              // this.initialCaseId;
              if (res.data.code == 0) {
                this.$message.success("补充信息成功");
                this.$router.go(-1);
              } else {
                this.$message.error(res.data.msg);
                this.fcdBtn = true;
              }
            })
            .catch((err) => {
              this.fcdBtn = true;
              console.log(err);
            });
        }
      } else {
        var data = {};
        console.log(this.reportcase);
        if (this.$route.query.creat) {
          //从创建关联案件过来的为创建案件
          this.initialCaseIdBtn = false;
        }
        if (this.initialCaseIdBtn) {
          //补充案件的时候不要关联ID
          delete this.reportcase.initialCaseId; //关联案件IDinitialCaseId
        } else {
          //创建
          this.reportcase.initialCaseId = this.initialCaseId;
          // delete this.reportcase.incidentId;
          delete this.reportcase.id;
          delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
          delete this.reportcase.xsId;
        }
        // if(this.reportcase.insuranceCompanyId == 8) {
        //   if(this.typeId == 800) {
        //   if(this.reportcase.insurancePolicyNo.length >20) {
        //   this.$message.error("保单位数超出20位，是否确认继续");
        //   // return;
        // }
        // if(this.reportcase.miniPolicy.length != 0) {
        //   if(this.reportcase.miniPolicy.length > 20) {
        //   this.$message.error("小保单位数超出20位，是否确认继续");
        //   // return;
        // }
        // }
        // }
        // }

        if (stil.judgeNull(this.reportcase.reportTs)) {
          this.$message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          this.$message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          this.$message.error("报案电话不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }

        //电话报案
        this.reportcase.token = this.token;
        this.reportcase.incidentTs = new Date(
          this.reportcase.incidentTs
        ).getTime();
        if(this.reportcase.patientTime != '') {
          this.reportcase.patientTime = new Date(
          this.reportcase.patientTime
        ).getTime();
        }
        if(this.reportcase.hospitalStartTime != '') {
          this.reportcase.hospitalStartTime = new Date(
          this.reportcase.hospitalStartTime
        ).getTime();
        }
        if(this.reportcase.hospitalEndTime != '') {
          this.reportcase.hospitalEndTime = new Date(
          this.reportcase.hospitalEndTime
        ).getTime();
        }
        console.log(new Date(this.reportcase.reportTs).getTime());
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime();
        if (this.reportcase.xsStart) {
          this.reportcase.xsStart = new Date(this.reportcase.xsStart).getTime(); //起始时间
        }
        if (this.reportcase.xsEnd) {
          this.reportcase.xsEnd = new Date(this.reportcase.xsEnd).getTime();
        }
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1;
        }
        this.domesticId = "";
        this.cooperaterDataList.forEach((item, index) => {
          if (index < this.cooperaterDataList.length - 1) {
            this.domesticId += "domesticId=" + item.id + "&";
          } else {
            this.domesticId += "domesticId=" + item.id;
          }
        });
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1;
        } else {
          this.reportcase.caseInsured = 2;
        }
        if (this.reportcase.channel == "旅责险") {
          this.reportcase.caseInsured = 3;
        }

        if (this.reportcase.caseInsured == 1 && this.alertyb) {
          this.dialogFormVisible1 = true;
          return;
        }

        this.fcdBtn = false;
        if (this.ruserId != "") {
          this.domesticId = this.domesticId + "&" + this.ruserId;
        }
        if (this.reportcase.channel == "其他") {
          this.reportcase.channel = this.reportcase.channel1;
        }
        data = Object.assign(this.reportcase, this.callCase);

        if (isNaN(data.incidentTs)) {
          data.incidentTs = "";
        }

        // return
        if (!status) {
          casecreateEditTempCase(data, this.domesticId)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$message.success("保存成功");
                this.reportcase.incidentId = res.data.obj;
                // if (this.$route.name == 'newstar') {
                this.$router.push({
                  name: "draftdetails",
                  query: { typeId: 900, caseId: res.data.obj },
                });
                // } else {
                //   this.$router.push({
                //     name: 'Homestart2',
                //     query:{typeId:800}
                //   })
                // }
              }
            })
            .catch((err) => {
              this.fcdBtn = true;
              console.log(err);
            });
        }
      }
    },
    getGps(id) {
      this.gpsBox = true;
      this.$refs.changeLanguage.setBtn();
      document.getElementsByTagName("body")[0].style.height = "100vh";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      if (id == 1) {
        this.$refs.gpsBox.parendZx(this.reportcase.addr, id);
      } else {
        this.$refs.gpsBox.parendZx(this.reportcase.rendezvous, id);
      }
    },
    getGpshid(data, data1, id) {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      if (data.lat == "") return;
      if (id == 1) {
        this.reportcase.latitude = data.lat;
        this.reportcase.longitude = data.lng;
        setTimeout(() => {
          // this.reportcase.addr = data.address;
          console.log(this.reportcase.addr);
        }, 1000);
        console.log(data1);
        if (data1 == undefined)
          return this.$message.error("地址未自动匹配，请手动添加！");
        if (data1.country == "中国") {
          this.reportcase.nation = "+86";
        } else {
          this.countries.forEach((item) => {
            if (item.label == data1.country) {
              this.reportcase.nation = item.value;
            }
          });
        }
      } else {
        this.reportcase.rlat = data.lat;
        this.reportcase.rlng = data.lng;
        setTimeout(() => {
          this.reportcase.rendezvous = data.address;
        }, 1000);
        if (data1 == undefined)
          return this.$message.error("地址未自动匹配，请手动添加！");
        if (data1.country == "中国") {
          this.reportcase.rCountryCode = "+86";
        } else {
          this.countries.forEach((item) => {
            if (item.label == data1.country) {
              this.reportcase.rCountryCode = item.value;
            }
          });
        }
      }
      this.loadcounties(data1, true, id);
    },
    getGpshid1() {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    },
    time: constants.time,
    judgeNull: function (val) {
      return stil.judgeNull(val);
    },
    handleSelectionChange(val) {
      this.cooperaterDataList1 = val;
    },
    toggleSelection(rows) {
      console.log(this.$refs);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getnowCase() {
      //当前案件管理
      var data = {
        token: this.token,
      };
      var getList = null;
      if (this.llrName.type == 4) {
        getList = getAllCoordinatedCases(data);
      } else {
        getList = getallGoingCase(data);
      }
      getList
        .then((res) => {
          this.nowCaseArr = res.data.obj;
          this.nowCaseArr1 = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    creatAboutFun() {
      if (this.creatAboutText == "")
        return (this.nowCaseArr = this.nowCaseArr1);
      this.nowCaseArr = this.nowCaseArr.filter((item) => {
        return item.obj.obj.caseNo == this.creatAboutText;
      });
    },
    handleAppCase1(obj) {
      this.handleAppCase(true, 0, false, obj.obj);
      this.initialCaseIdBtn = true;
      this.centerDialogVisible = false;
    },
    getRuserId(id) {
      this.ruserId = id;
      console.log(id);
    },
  },
};

var stil = strutils;

function forpst(obj) {
  if (stil.judgeNull(obj)) return "";
  var ks = Object.keys(obj);
  var postdata = "";
  for (var i = 0; i < ks.length; ++i) {
    var d = obj[ks[i]];
    if (d == null) continue;
    if (d.constructor == Array) {
      for (var j = 0; j < d.length; ++j) {
        postdata += ks[i] + "=" + encodeURIComponent(d[j]);
        if (j != d.length - 1) {
          postdata += "&";
        }
      }
    } else if (d.constructor == Date) {
      postdata += ks[i] + "=" + d.getTime();
    } else {
      postdata += ks[i] + "=" + encodeURIComponent(d);
    }
    if (i != ks.length - 1) {
      postdata += "&";
    }
  }
  return postdata;
}

function s2c(cmd) {
  fetch(cmd.url, {
    method: "POST",
    body: forpst(cmd.data),
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then(function (res) {
      //console.log(res);
      return res.json();
    })
    .then(function (data) {
      if (data.code != 0) {
        var handled = false;
        if (cmd.transerr != null) {
          handled = cmd.transerr(data.code);
        }
        if (!handled) {
          var errtxt = e2t(data.code);
          this.$message.error(errtxt);
        }
      } else {
        cmd.succ(data.obj);
      }
    });
}

function e2t(errcode) {
  errcode = "ERR_" + errcode;
  if ("ERR_100001" == errcode) return "参数异常，请重新提交";
  if ("ERR_101000" == errcode) return "登录过期，请重新登录";
  if ("ERR_102000" == errcode) return "用户类型错误";
  if ("ERR_102002" == errcode) return "找不到此机构";
  if ("ERR_102003" == errcode) return "合约已失效";
  if ("ERR_102004" == errcode) return "案件状态错误，无法更新";
  if ("ERR_102005" == errcode) return "案件更新失败";
  if ("ERR_102006" == errcode) return "找不到此机构";
  if ("ERR_102007" == errcode) return "机构保存错误";
  if ("ERR_102008" == errcode) return "找不到此机构合约";
  if ("ERR_102009" == errcode) return "找不到此机构收费方式";
  if ("ERR_102010" == errcode) return "合约保存错误";
  if ("ERR_102011" == errcode) return "找不到此用户";
  if ("ERR_102012" == errcode) return "此案件已创立";
  if ("ERR_101001" == errcode) return "找不到此案件";
  if ("ERR_101002" == errcode) return "找不到方案";
  if ("ERR_101003" == errcode) return "您没有操作权限，请联系管理员";
  if ("ERR_102000" == errcode) return "找不到当前操作状态";
  if ("ERR_101004" == errcode) return "找不到案件出险人";
  if ("ERR_101010" == errcode) return "找不到此方案对应的服务清单";
  if ("ERR_101005" == errcode) return "此案件未推送机构";
  if ("ERR_101006" == errcode) return "救援机构尚未提交方案";
  if ("ERR_101007" == errcode) return "此案已审核，不能修改";
  if ("ERR_101008" == errcode) return "请勿重新提交方案";
  if ("ERR_101009" == errcode) return "找不到此上传资源，无法修改";
  if ("ERR_100000" == errcode) return "未知错误";
  return errcode;
}

function uniq(array) {
  var temp = [];
  var index = [];
  var l = array.length;
  for (var i = 0; i < l; i++) {
    for (var j = i + 1; j < l; j++) {
      if (array[i].cityCode == array[j].cityCode) {
        i++;
        j = i;
      }
    }
    temp.push(array[i]);
    index.push(i);
  }
  return temp;
}
</script>

<style scoped>
@import url("./../style.css");

/* @import url("./js/elementUI/index.css"); */
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.uploadStyle {
  margin-top: 15px;
  margin-left: 10px;
}

.uploadStyle span {
  float: left;
  width: 110px;
  font-size: 14px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.serviceBrief ul li h4 {
  border-bottom: 1px solid #eee;
  width: 200px;
  line-height: 24px;
}

.serviceBrief ul li h4 small {
  margin-left: 35px;
}

.el-row {
  margin-bottom: 20px;

  /* &:last-child {
      margin-bottom: 0;
    } */
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #f5f5f5;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  margin-top: 10px;
  text-align: center;
  line-height: 36px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

input.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.margint10 {
  padding-top: 10px;
}

.marginl10 .contactAddStyle {
  cursor: pointer;
  margin-left: 30px;
  float: right;
  font-size: 13px;
  color: #484646;
  font-weight: 400;
}

.marginl10 .contactAddStyle::before {
  content: "+";
  color: #00abf9;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 7.5px;
  text-align: center;
  line-height: 15px;
  font-size: 16px;
  margin-right: 5px;
  border: 1px solid #00abf9;
}

.el-input,
.el-select {
  width: 50%;
}

.el-input__inner,
.el-input--suffix {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 50%;
}

.lisave {
  font-size: 10px;
  color: #399cff;
  cursor: pointer;
}

.w140 {
  width: 140px;
}

.w213 {
  width: 213px;
}

.w120 {
  width: 120px;
}

.f10 {
  font-size: 10px;
}

.w75 {
  width: 75px;
}

.w130 {
  width: 130px;
}

.w303 {
  width: 303px;
  display: inline-block;
}

.w88100 {
  width: 88%;
  display: inline-block;
}

.w200 {
  width: 200px;
}

.mgt5 {
  margin-top: 5px;
}

.mgt15 {
  margin-top: 15px;
}

.p1026 {
  padding: 10px 26px;
}

.h50 {
  height: 50px;
  line-height: 50px;
}

.span_node {
  font-weight: normal;
  font-size: 14px;
}

.w100 {
  width: 100px;
}

.app-aj div {
  padding: 0;
  margin: 10px 0;
}

.lianluo {
  overflow: hidden;
  font-size: 14px;
  margin-top: 20px;
  padding: 0 15px;
}

.lianluo li {
  float: left;
  width: 50%;
}

.lianluo li .must {
  color: red;
}

.marginCenter {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
  padding-top: 20px;
}

.blue {
  color: #00abf9;
  cursor: pointer;
}

.gpsBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: powderblue;
  overflow: hidden;
}

.back {
  background: url(./../images/back.png) left center no-repeat;
  padding-left: 20px;
  background-size: 15px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/createAcase.vue